// le variabili per il nome dell'app sono definite 
// nel file di configurazione di build (es. webpack.config.js)
// @ts-nocheck
// eslint-disable-next-line no-undef
export const APP_NAME = __APP_NAME__;
// eslint-disable-next-line no-undef
export const APP_NAME_SHORT = __APP_NAME_SHORT__;

// import packageJson from '../../package.json';
// export const APP_VERSION = packageJson.version;
// __VERSION__ è definito da webpack in fase di build, e contiene la versione dell'applicazione, ad esempio "1.0.0". Se non è definito, usiamo "0.0.0" come default.
// eslint-disable-next-line no-undef
export const APP_VERSION = __VERSION__ || "?";
//__ENVIRONMENT__ è definito da webpack in fase di build, e può essere "production", "development", etc. Se non è definito, usiamo "production" come default.
// eslint-disable-next-line no-undef
export const ENVIRONMENT = __ENVIRONMENT__ || "production";

//#region STATIC CONFIG
/**
 * Costante per abilitare il formato del nome visualizzato gestito esternamente da matrixClient (in base al contact_format)
 * se true, il display name dei contatti, in rubrica, in registro chiamate e nelle chat viene aggiornato dinamicamente in base alla configurazione contact_format
 * se false, viene gestito solo il display name solo dei contatti della rubrica e in registro chiamate (chat escluse)
 */
export const CONTACT_FORMAT_CAN_CHANGE_DISPLAY_NAME_IN_CHAT = false;

/**
 * Costante per abilitare la nuova UI della room list.
 * Se true, DTH utilizza la nuova interfaccia utente per la visualizzazione della lista delle stanze.
 * Se false, viene utilizzata l'interfaccia utente precedente per la lista delle stanze.
 */
export const ENABLE_NEW_ROOM_LIST = true; //SettingsStore.getValue("feature_new_room_list");

/**
 * Costante per abilitare la funzionalità di creazione dei sondaggi.
 * Se true, gli utenti possono creare sondaggi nelle chat.
 * Se false, la funzionalità di creazione dei sondaggi è disabilitata e non sarà visibile nell'interfaccia utente.
 */
export const ENABLE_CREATE_POLL = false;

/**
 * Costante per abilitare la funzionalità di anteprima dei link.
 * Se true, gli utenti possono configurare se vedere un'anteprima dei link condivisi nelle chat.
 * Se false, la funzionalità di anteprima dei link è disabilitata e non sarà visibile nell'interfaccia utente.
 * ATTENZIONE: l'attuale soluzione non va bene perchè fa uso di servizi esterni per generare le anteprime, 
 * e questo potrebbe comportare problemi di CORS, oltre che di privacy e sicurezza.
 * In futuro, se si vorrà abilitare questa funzionalità, sarà necessario implementare una soluzione interna lato server Matrix per generare le anteprime dei link.
 */
export const ENABLE_CONFIG_LINK_PREVIEW = false;

/**
 * If true, skip bootstrapping cross-signing keys and uploading them to the homeserver.
 * Useful for deployments that don't support UIA or where device verification is not needed.
*/
export const SKIP_CROSS_SIGNING_BOOTSTRAP = true;

/**
 * If true, skip user verification during encryption setup. 
 * This is useful for deployments that don't support UIA or where device verification is not needed.
 */
export const SKIP_USER_VERIFICATION = true;

/**
 * If true, the app will enable and use offline recovery key backup.
 * This allows users to backup their encryption keys locally, without inserting them each login.
 */
export const ENABLE_RECOVERY_KEY_BACKUP_OFFLINE = true;

/**
 * If true, the app will delete the locally stored recovery key when a user logs out or when a different user logs in.
 */
export const DELETE_RECOVERY_KEY_ON_ACCOUNT_CHANGE = false;

//#endregion


//#region Room constants
export const GENERIC_ROOM = "__generic_room__";
//#endregion

//#region LOCAL STORAGE KEY
export const API_PASSWORD_KEY = "password";
export const M_DIRECT_EVENT_CACHE_KEY = "mx_mdirect_event_cache";
export const API_PRIVATE_CONFIGURATION = "api_private_conf";
export const API_CONTACTS = "api_contacts";

//#region IMatrixClientCreds
export const TABLE_ACCOUNT_NAME_STORAGE = "account";
export const TABLE_PICKLEKEY_NAME_STORAGE = "pickleKey";
export const ACCESS_TOKEN_IV = "access_token";
export const REFRESH_TOKEN_IV = "refresh_token";
export const HOMESERVER_URL_KEY = 'homeserver_url';
export const ID_SERVER_URL_KEY = 'identity_server_url';
export const MX_USER_ID_KEY = 'mx_user_id';
export const MX_IS_GUEST_KEY = 'mx_is_guest';
export const API_EXPIRATION_TOKEN_KEY = 'api_expiration_token';
export const MX_DEVICE_ID_KEY = 'mx_device_id';
export const MX_HAS_PICKLE_KEY = 'mx_has_pickle_key';
export const MX_FRESH_LOGIN_KEY = 'mx_fresh_login';
export const API_USER_ID_KEY = "api_user_id";

export const API_ACCESS_TOKEN_STORAGE_KEY = "api_access_token";
export const API_REFRESH_TOKEN_STORAGE_KEY = "api_refresh_token";
export const MX_ACCESS_TOKEN_STORAGE_KEY = "mx_access_token";
export const MX_REFRESH_TOKEN_STORAGE_KEY = "mx_refresh_token";
export const HAS_MX_ACCESS_TOKEN_STORAGE_KEY = "mx_has_access_token";
export const HAS_MX_REFRESH_TOKEN_STORAGE_KEY = "mx_has_refresh_token";
export const HAS_API_ACCESS_TOKEN_STORAGE_KEY = "api_has_access_token";
export const HAS_API_REFRESH_TOKEN_STORAGE_KEY = "api_has_refresh_token";
//#endregion

//#region IDthUser
export const API_EMAIL_KEY = "api_email";
export const API_USERNAME_KEY = "api_username";
export const API_FIRST_NAME_KEY = "api_first_name";
export const API_LAST_NAME_KEY = "api_last_name";
export const API_PHONE_KEY = "api_phone";
export const API_ROLE_KEY = "api_role";
export const API_STATUS_KEY = "api_status";
export const API_MATRIX_NAME_KEY = "api_matrix_name";
export const API_GOT_ID_KEY = "api_got_id";
export const API_DEACTIVATED_KEY = "api_deactivated";
export const API_SHADOW_BANNED_KEY = "api_shadow_banned";
export const API_AUTH_APP_ENABLED_KEY = "api_auth_app_enabled";
export const API_PIN_LOCK_KEY = "api_pin_lock_enabled";
export const API_BIOMETRIC_KEY = "api_biometric_enabled";
export const API_AUTH_PROVIDER_KEY = "api_auth_provider";
export const API_CREATION_DATE_KEY = "api_creation_date";
export const API_LAST_UPDATE_KEY = "api_last_update";
export const API_DEVICES_KEY = "api_devices"; // stringified JSON
export const API_CONFIGURATION_KEY = "api_configuration"; // stringified JSON
export const API_TELEMETRY_TOKEN_KEY = "api_telemetry_token";
export const API_FISCAL_CODE_KEY = "api_fiscal_code";
//#endregion
//#endregion

//#region AUTH PROVIDERS
export const AUTH_PROVIDER_ENTRA_ID = "OAUTH2_ENTRA_ID";
export const AUTH_PROVIDER_CREDENTIALS = "CREDENTIALS";

export type AUTH_PROVIDER_TYPE = typeof AUTH_PROVIDER_CREDENTIALS | typeof AUTH_PROVIDER_ENTRA_ID;

export function getAuthProviderFromString(provider: string | null | undefined): AUTH_PROVIDER_TYPE | null {
    const providerUpper = provider?.toUpperCase();   
    if (providerUpper != null &&
        (providerUpper === AUTH_PROVIDER_CREDENTIALS || providerUpper === AUTH_PROVIDER_ENTRA_ID)) {
        return providerUpper as AUTH_PROVIDER_TYPE;  // Restituisce la stringa con il tipo corretto
    }
    return null;  // Tipo di fallback se la stringa non corrisponde
}

//#endregion

//#region Licensing
export const LICENSE_JWT_KEY = "dth_license_jwt";
export const LICENSE_JWT_LOGIN_KEY = "dth_license_jwt_login";
//#endregion

export const PASSWORD_REGEX: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!$£%^&#@°*()_+|~=`{§}\[\]:;"'<>,.?\/\\-])[0-9a-zA-Z!$£%^&#@°*()_+|~=`{§}\[\]:;"'<>,.?\/\\-]{8,}$/;
export const USERNAME_REGEX: RegExp = /^[A-Za-z0-9]+(?:[._-][A-Za-z0-9]+)*$/;
export const EMAIL_REGEX: RegExp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const FISCAL_CODE_REGEX: RegExp = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
